import { Box } from '@mui/material';
import { RiCloseLine, RiSaveLine } from '@remixicon/react';
import { deviceType } from 'detect-it';
import { AgButton } from 'src/components/ui';
import type { GridApiRef } from 'src/modules/grids';

export default function GridActionsToolbar({ apiRef }: { apiRef: GridApiRef }) {
  const api = apiRef.current;
  const cell = api?.state?.focus?.cell;

  if (!api || !cell || deviceType === 'mouseOnly') {
    return null;
  }

  return (
    <Box
      className="flex items-center bg-white shadow-xl rounded-lg mx-auto px-5 gap-1"
      sx={{
        position: 'fixed',
        top: '48px',
        left: 0,
        right: 0,
        maxWidth: '85vw',
        minHeight: '62px',
        zIndex: 1201,
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <AgButton
        variant="destructive-ghost"
        onPress={() => {
          api.stopRowEditMode({ ...cell, ignoreModifications: true });
        }}
      >
        <RiCloseLine size={20} />
        Cancel
      </AgButton>
      <AgButton
        variant="primary"
        onPress={() => {
          api.stopRowEditMode({ ...cell, ignoreModifications: true });
        }}
      >
        <RiSaveLine size={20} />
        Save
      </AgButton>
    </Box>
  );
}
